<template>
  <el-container>
    <main class="page__container page__container--fix container">
      <div class="container">
        <h2 class="page__title">Добавить DVR сервер</h2>
        <el-form ref="form" label-position="top" :model="form" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Платформа" prop="id_media_core">
                <el-switch
                  v-model="form.id_media_core"
                  :active-value="MEDIA_CORE.VK3"
                  :inactive-value="MEDIA_CORE.VK2"
                  :active-text="MEDIA_CORE_NAME[MEDIA_CORE.VK3]"
                  :inactive-text="MEDIA_CORE_NAME[MEDIA_CORE.VK2]"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="server_domain" label="Имя">
                <el-input size="small" v-model="form.server_domain" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Статус сервера" prop="id_server_mode">
                <select-servers-mode v-model="form.id_server_mode" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Максимальное количество камер" prop="max_cameras_count">
                <el-input-number size="small" :min="0" :max="5000" v-model="form.max_cameras_count" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Размер хранилища [ТБ]" prop="archive_size">
                <el-input-number id="archive_size" size="small" :min="0" :max="5000" v-model="form.archive_size" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Чистить архивы" prop="clean_archive">
                <el-switch v-model="form.clean_archive" :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="API-ключ AVC панели" prop="avc_panel_api_key">
                <el-input v-model="form.avc_panel_api_key" size="small" placeholder="api_key" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Группа серверов" prop="id_server_group">
                <template slot="label">
                  Группа серверов
                  <el-tooltip class="item" effect="light" placement="top-start">
                    <template slot="content">
                      Группа влияет на <code>rules.conf</code> сервера. Оставить пустым для настроек по умолчанию
                    </template>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
                <el-select
                  v-model="form.id_server_group"
                  size="small"
                  placeholder="Нет группы"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="val in serverGroups"
                    :key="val.id_server_group"
                    :label="val.server_group_name"
                    :value="val.id_server_group"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button
        class="page__active_button"
        type="primary"
        icon="el-icon-check"
        :loading="isCreating"
        @click="onCreate"
      >
        Сохранить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { length, required } from "@/core/helpers/validators";
import SelectServersMode from "@/components/Server/feature/SelectServersMode";
import { ApiService } from "@/api";
import {mapActions} from "vuex";
import { MEDIA_CORE, MEDIA_CORE_NAME } from "@/core/helpers/const";

export default {
  name: "ServerCreate",
  components: { SelectServersMode },
  data() {
    return {
      isCreating: false,
      serverGroups: [],
      MEDIA_CORE,
      MEDIA_CORE_NAME,
      // Состав по ТЗ 1.1.2. Идентификатор убран — имя сервера и есть идентификатор,
      // is_managed_by_avc_panel убран: в ВК 3.0 выбора механизма управления больше нет (ТЗ 1.2).
      form: {
        // По ТЗ 1.1.2 свитч платформы по умолчанию в положении ВК 3.0.
        id_media_core: MEDIA_CORE.VK3,
        server_domain: "",
        max_cameras_count: null,
        archive_size: null,
        clean_archive: null,
        id_server_mode: null,
        avc_panel_api_key: "",
        id_server_group: null,
      },
      rules: {
        server_domain: [required(), length(3, 100)],
        max_cameras_count: [required("number")],
        archive_size: [required("number")],
        clean_archive: [required("number")],
        id_server_mode: [required("number")],
      },
    };
  },
  created() {
    this.getServerGroups()
      .then((res) => {
        this.serverGroups = res
        }
      );
  },
  methods: {
    ...mapActions("server", {
      getServerGroups: "GET_SERVER_GROUPS",
    }),
    onCreate() {
      this.$refs["form"].validate((status) => {
        return status ? this.createServer() : false;
      });
    },
    createServer() {
      this.isCreating = true;

      return ApiService.servers
        .create(this.form)
        .then(({ id_server: id }) => {
          this.$message({
            type: "success",
            message: "DVR сервер успешно создан",
          });
          this.$router.push({ name: "servers:edit", params: { id } });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.response.data.error || "Неизвестная ошибка",
          });
        })
        .finally(() => {
          this.isCreating = false;
        });
    },
  },
};
</script>
